var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMusicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5073 3.18624C19.0457 3.1864 16.6305 2.51732 14.5198 1.2506L13.9519 0.910464C13.831 0.837855 13.6931 0.798623 13.5521 0.796776C13.4111 0.794928 13.2722 0.830531 13.1495 0.899948C13.0268 0.969366 12.9247 1.07011 12.8536 1.19189C12.7826 1.31367 12.7451 1.45213 12.7451 1.59312V15.2231C11.841 14.3011 10.6446 13.7219 9.36065 13.5844C8.07667 13.447 6.78482 13.76 5.70607 14.4697C4.62732 15.1795 3.82868 16.2421 3.44674 17.4756C3.0648 18.7091 3.1233 20.0371 3.61222 21.2322C4.10115 22.4274 4.99013 23.4156 6.12712 24.0278C7.2641 24.64 8.57846 24.8381 9.84539 24.5883C11.1123 24.3385 12.2531 23.6563 13.0726 22.6584C13.8922 21.6605 14.3395 20.4088 14.3382 19.1175V7.75851C16.543 8.94024 19.0058 9.55866 21.5073 9.55874C21.7186 9.55874 21.9212 9.47482 22.0706 9.32543C22.2199 9.17605 22.3039 8.97344 22.3039 8.76218V3.98281C22.3039 3.77154 22.2199 3.56894 22.0706 3.41955C21.9212 3.27017 21.7186 3.18624 21.5073 3.18624Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicIcon);
export default __webpack_public_path__ + "static/media/musicIcon.3595579da5ca1b1a298128693bda0eb4.svg";
export { ForwardRef as ReactComponent };